import { TranslateFunction } from 'react-localize-redux';

const localizePaymentMethodLabel = (
  paymentMethod: string,
  translate: TranslateFunction,
): string => {
  if (paymentMethod === 'Cash') {
    return `${translate('Cash')}`;
  }

  if (paymentMethod.startsWith('Card')) {
    const cardNumberMask = paymentMethod.indexOf('*');
    const cardNumber = paymentMethod.slice(cardNumberMask) || '';

    return `${translate('Card')} ${cardNumber}`;
  }

  const isGoogleApplePay = paymentMethod.startsWith('PayButton');
  if (isGoogleApplePay) {
    const payButton = paymentMethod.substring(10);
    const cardNumberMask = payButton.indexOf('*');
    const cardNumber = payButton.slice(cardNumberMask) || '';

    return `${translate('Card')} ${cardNumber}`;
  }

  return paymentMethod;
};

export const orderHistoryUtils = {
  localizePaymentMethodLabel,
};
